import React, { useState, useCallback } from "react";
import kisok from "../Assests/kioskImage/kioskImage.png";
import spec1 from "../Assests/kioskImage/spec.png";
import spec2 from "../Assests/kioskImage/spec1.png";
import spec3 from "../Assests/kioskImage/spec2.png";
import spec4 from "../Assests/kioskImage/spec3.png";
import spec5 from "../Assests/kioskImage/spec4.png";
const Specification = () => {
  const [activeHotspot, setActiveHotspot] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  const hotspots = [
    {
      id: 1,
      title: "Digital Sphygmomanometer",
      description: "Precision in Every Pulse",
      image: spec2,
    },
    {
      id: 2,
      title: "Glucometer",
      description: "Reliable Glucose Monitoring",
      image: spec4,
    },
    {
      id: 3,
      title: "Body Composition Analysis",
      description: "Know Your Body, Transform Your Health",
      image: spec1,
    },
    {
      id: 4,
      title: "Pulse Oximeter",
      description: "Breathe Easy, Monitor with Accuracy",
      image: spec3,
    },
    {
      id: 5,
      title: "Single Lead ECG Device",
      description: "Instant Heart Monitoring with Reliability",
      image: spec5,
    },
  ];

  const hoverImg = [
    // {
    //   id: 1,
    //   x: 50,
    //   y: 1,
    //   title: "Camera",
    //   description: "Precision in Every Pulse",
    //   image: spec2,
    // },
    {
      id: 2,
      x: 70,
      y: 30,
      title: "Display",
      description: "Reliable Glucose Monitoring",
      image: spec4,
    },
    {
      id: 3,
      x: 75,
      y: 60,
      title: "Body Composition Analysis",
      description: "Know Your Body, Transform Your Health",
      image: spec1,
    },
  ];

  const handleHotspotHover = useCallback((hotspot, event) => {
    const rect = event.target.getBoundingClientRect();
    const scrollY = window.scrollY;
    let x = rect.left;
    let y = rect.top + scrollY;
    const viewportWidth = window.innerWidth;

    if (x > viewportWidth) {
      x = x - 50 + rect.width;
    }
    setTooltipPosition({ x, y: y - 50 });
    setActiveHotspot(hotspot);
  }, []);

  const handleHotspotLeave = useCallback(() => {
    setActiveHotspot(null);
  }, []);

  return (
    <div className="specification-container">
      {/* Header Section (1 Column) */}
      <div className="spec-header">
        <div className="spec-left">
          <button className="spec-button">Specification</button>
        </div>
      </div>

      <div className="spec-main-content">
        <div className="spec-img-container">
          <div className="spec-img">
            <img src={kisok} alt="AI Kiosk" />
            {/* {hoverImg.map((hotspot) => (
              <div
                key={hotspot.id}
                className="hotspot"
                style={{ left: `${hotspot.x}%`, top: `${hotspot.y}%` }}
                onMouseEnter={(e) => handleHotspotHover(hotspot, e)}
                onMouseLeave={handleHotspotLeave}
              />
            ))} */}
          </div>
        </div>

        <div className="spec-right">
          <div className="spec-items-container">
            {hotspots.map((hotspot) => (
              <div key={hotspot.id} className="spec-item">
                <img
                  src={hotspot.image}
                  alt={hotspot.title}
                  className="spec-item-img"
                />
                <div className="spec-item-content">
                  <p>{hotspot.title}</p>
                  <p>{hotspot.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* {activeHotspot && (
        <div
          className={`tooltip ${activeHotspot ? "visible" : ""}`}
          style={{
            left: `${tooltipPosition.x}px`,
            top: `${tooltipPosition.y}px`,
          }}
        >
          <h3 className="tooltip-title">{activeHotspot.title}</h3>
        </div>
      )} */}
    </div>
  );
};

export default Specification;
